import { render, staticRenderFns } from "./WebPartFormSubmitDesigner.vue?vue&type=template&id=097910c7&"
import script from "./WebPartFormSubmitDesigner.vue?vue&type=script&lang=js&"
export * from "./WebPartFormSubmitDesigner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('097910c7')) {
      api.createRecord('097910c7', component.options)
    } else {
      api.reload('097910c7', component.options)
    }
    module.hot.accept("./WebPartFormSubmitDesigner.vue?vue&type=template&id=097910c7&", function () {
      api.rerender('097910c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/featureOnePage/webParts/WebPartFormSubmitDesigner.vue"
export default component.exports